import { useState } from "react";
import styles from "./styles.module.css";
import modalState from "../../../state-observables/modal/ModalState";
import LoadingPage from "../../LoadingSpinner";
import ColourSensorManualCalibrator from "@robotical/ricjs-robotical-addons/dist/ColourSensorManualCalibrator";
import { RICConnector } from "@robotical/ricjs";
import Infographic from "../infographic.jpg";

type ColourSensorCalibrationProcessProps = {
  ricConnector: RICConnector;
};

function ColourSensorCalibrationProcess({ ricConnector }: ColourSensorCalibrationProcessProps) {
  const [isCalibrationComplete, setIsCalibrationComplete] = useState(false);
  const [isCalibrating, setIsCalibrating] = useState(false);
  const [didCalibrationFail, setDidCalibrationFail] = useState(false);

  const onStart = async () => {
    setIsCalibrationComplete(false);
    setIsCalibrating(true);
    const didCalibrate = await ColourSensorManualCalibrator.calibrate(ricConnector);
    setDidCalibrationFail(!didCalibrate);
    setIsCalibrationComplete(true);
    setIsCalibrating(false);
  };

  const onClose = () => {
    modalState.closeModal();
  };

  return (
    <div className={styles.container}>
      {
        isCalibrationComplete && !didCalibrationFail ?
          <p>Calibration is complete!</p>
          :
          <p>Colour sensor(s) calibration is about to start. Please make sure Marty is on a white surface. Once ready, press Start Calibration.</p>
      }
      <div className={styles.infographic_container}>
        <img src={Infographic} alt="Infographic" className={styles.infographic} />
      </div>
      {didCalibrationFail && (
        <div className={styles.errorContainer}>
          <p className={styles.errorText}>Calibration Failed</p>
          <div className={styles.errorText}>
            Oops! Something didn't go quite right. 😕 Please try the calibration process in our phone or <a href="https://marty-webapp.web.app/">web</a> applications.
            <ul>
              <li>Go to <strong>Configuration</strong></li>
              <li>Navigate to <strong>Calibration</strong></li>
              <li>Select <strong>Colour Sensor Calibration</strong></li>
            </ul>
            If you encounter any further issues, don't hesitate to reach out to our support team at <a href="mailto:support@robotical.io">support@robotical.io</a>.
          </div>
        </div>
      )}
      {isCalibrating ? (
        <div className={styles.loadingContainer}>
          <LoadingPage />
        </div>

      ) :
        <div className={styles.buttonContainer}>

          <button className={!isCalibrationComplete ? styles.submitButton : styles.closeButton} onClick={onStart}>
            {!isCalibrationComplete ? "Start Calibration" : "Recalibrate"}
          </button>
          {isCalibrationComplete && (
            <button className={isCalibrationComplete ? styles.submitButton : styles.closeButton} onClick={onClose}>
              {!didCalibrationFail ? "Save and Close" : "Close"}
            </button>
          )}
        </div>}
    </div>
  );
}

export default ColourSensorCalibrationProcess;
